export default {
  'sidebar.policy': 'Hợp đồng BH',
  'sidebar.claim': 'Đơn bồi thường',
  'sidebar.upload': 'Tải lên',
  'sidebar.dashboard': 'Bảng điều khiển',
};
